import { render, staticRenderFns } from "./support.vue?vue&type=template&id=4c18e44f&scoped=true&"
import script from "./support.vue?vue&type=script&lang=js&"
export * from "./support.vue?vue&type=script&lang=js&"
import style0 from "./support.vue?vue&type=style&index=0&id=4c18e44f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c18e44f",
  null
  
)

export default component.exports